import React, { useState } from "react";
import { useLsp } from "../store/LspContext";
import { apiLoanStatus } from "../api/lspApi";

export default function LoanStatusPage() {
    const { state } = useLsp();
    const [out, setOut] = useState("");
    const [loading, setLoading] = useState(false);

    const run = async () => {
        setLoading(true); setOut("");
        try {
            const res = await apiLoanStatus(state.baseUrl, state.token, state.partnerLoanId);
            setOut(JSON.stringify(res, null, 2));
        } catch (e) {
            setOut("❌ " + e.message);
        } finally { setLoading(false); }
    };

    return (
        <div style={card}>
            <h2 style={h2}>3) Get Loan Status</h2>
            <button style={btn} onClick={run} disabled={loading || !state.token || !state.partnerLoanId}>
                Get Status
            </button>
            <pre style={pre}>{loading ? "⏳ loading..." : out || "No response yet"}</pre>
        </div>
    );
}
const card = { padding: 16, border: "1px solid #334155", borderRadius: 12, background: "#0f172a" };
const h2 = { marginTop: 0 };
const btn = { padding: "10px 14px", borderRadius: 10, border: "1px solid #475569", background: "#1f2937", color: "#e5e7eb", cursor: "pointer" };
const pre = { marginTop: 12, background: "#fffff", border: "1px solid #334155", borderRadius: 10, padding: 12, overflow: "auto", maxHeight: 360 };
